// extracted by mini-css-extract-plugin
module.exports = {"rootContainer":"Root__rootContainer___1nXOp","rootContent":"Root__rootContent___2qWI7"};